import styled, { keyframes } from "styled-components"

const spin = keyframes`
  to { transform: rotate(360deg); }
`

export const Container = styled.div`
  width: 100%;
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  h3 {
    margin: 0;
    font-size: 1.6rem;
    color: ${(p) => p.theme.colors.black};
  }
`

export const TableGrid = styled.div`
  > div:first-child {
    padding-left: 2rem;
  }

  > div > div:first-child,
  > div > div > div:first-child {
    border-left: none;
    padding-left: 0;
  }

  > div > div,
  > div > div > div {
    flex: 1;
    min-width: 0;
  }

  > div > div.col-workflow-name,
  > div > div > div.col-workflow-name {
    flex: 2.5;
  }

  > div > div.col-revision,
  > div > div > div.col-revision {
    flex: 0.4;
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  color: ${(p) => p.theme.colors.greyDarker};
  font-size: 1.3rem;
`

export const RefreshButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: none;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  padding: 0.4rem 1rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.greyDarker};
  cursor: pointer;

  &:hover {
    background: ${(p) => p.theme.colors.greyLighter};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const RefreshSpinner = styled.span`
  width: 1.2rem;
  height: 1.2rem;
  border: 0.2rem solid ${(p) => p.theme.colors.greyLight};
  border-top-color: ${(p) => p.theme.colors.greyDarker};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`

export const LoadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem 0;
`

export const LoadMoreButton = styled.button`
  background: none;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  padding: 0.6rem 2rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.turquoiseDark};
  cursor: pointer;
  ${(p) => p.theme.bold};

  &:hover {
    background: ${(p) => p.theme.colors.turquoiseLighter};
  }
`

export const WorkflowName = styled.span`
  ${(p) => p.theme.bold};
  font-size: 1.3rem;
  color: ${(p) => p.theme.colors.black};
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: help;

  &:hover {
    color: ${(p) => p.theme.colors.turquoiseDark};
    overflow: visible;
    white-space: normal;
    word-break: break-word;
    position: relative;
    z-index: 2;
  }
`

export const WorkflowIdCell = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
`

export const WorkflowIdText = styled.span`
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDarker};
  font-family: monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  min-width: 0;
  flex: 1;
`

export const OrderIdLink = styled.a`
  font-size: 1.1rem;
  font-family: monospace;
  color: ${(p) => p.theme.colors.turquoiseDark};
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

export const DateText = styled.p`
  white-space: nowrap;
  margin: 0;
  font-size: 1.2rem;
`

export const DurationText = styled.span`
  font-family: monospace;
  font-size: 1.1rem;
  white-space: nowrap;
`

export const TriggerBadge = styled.span`
  background: ${(p) => p.theme.colors.turquoiseLighter};
  color: ${(p) => p.theme.colors.turquoiseDark};
  padding: 0.2rem 0.8rem;
  border-radius: 0.4rem;
  font-size: 1.1rem;
  ${(p) => p.theme.bold};
`

export const RowActions = styled.div`
  display: flex;
  align-items: center;
`

export const RetryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 1.2rem;
  border: 0.1rem solid ${(p) => p.theme.colors.yellowDark};
  border-radius: 0.4rem;
  background: ${(p) => p.theme.colors.white};
  color: #92400e;
  font-size: 1.2rem;
  cursor: pointer;
  ${(p) => p.theme.bold};

  &:hover {
    background: ${(p) => p.theme.colors.yellowLighter};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const RetrySpinner = styled.span`
  width: 1rem;
  height: 1rem;
  border: 0.2rem solid ${(p) => p.theme.colors.yellowLighter};
  border-top-color: #92400e;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`
